import type { TCreateSlice } from "@/store";

type TStateSettings = {
    settingsOpen: boolean;
};

type TActionsPublicSettings = {
    toggleSettings: () => void;
};

export type TSliceSettings = TStateSettings & TActionsPublicSettings;

export const initialStateSettings = {
    settingsOpen: false,
} as const satisfies TStateSettings;

export const createSliceSettings: TCreateSlice<
    TSliceSettings,
    Record<string, never>
> = () => set => {
    const actionsPublic: TActionsPublicSettings = {
        toggleSettings: () =>
            set(
                state => ({ settingsOpen: !state.settingsOpen }),
                false,
                "settings/toggleSettings",
            ),
    };

    return {
        ...initialStateSettings,
        ...actionsPublic,
    };
};
